import { render } from "./FileContent.vue?vue&type=template&id=9f27d37c"
import script from "./FileContent.vue?vue&type=script&lang=js"
export * from "./FileContent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__